import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Nav, Container, Row, Col, Form, Button, Dropdown } from 'react-bootstrap';
import config from 'react-global-configuration';
import axios from 'axios';
import ApexCharts from 'apexcharts';
import HeaderComponent from '../../components/header';

import toastr from "toastr";
import ReportRisks from './reportRisks';
import ReportGroup from './reportGroup';
import ReportGestao from './reportGestao';
import ReportDados from './reportDados';
import ReportFrameworks from './reportFrameworks';
import ReportCNPJs from './reportCNPJs';
import ReportEmpresas from './reportEmpresas';
import ReportProcessos from './reportProcessos';
import ReportMidias from './reportMidias';
import ReportCarbono from './reportCarbono';

import { cnpjMask, cpfMask } from '../../shared/mask';

function ReportDetails() {

    const [activeTab, setActiveTab] = useState('');
    const [data, setData] = useState([]);
    const [dataSelected, setDataSelected] = useState(null);
    const [docreport, setDocreport] = useState('');
    const [load, setLoad] = useState(false);
    const [filtrosEsfera, setFiltrosEsfera] = useState({
        Social: true,
        Governança: true,
        Ambiental: true
    });
    const { state } = useLocation();

    const rendeGraph = (score, type) => {
        score = !score || score <= 0 ? 0.05 : score;
            
        const colors = {
            ambiental: '#BDD714',
            social: '#652FBA',
            governanca: '#0B407F',
        };

        if (type !== 'score') {
            var options = {
                series: [score],
                colors: [colors[type]],
                chart: {
                    type: 'radialBar',
                    offsetY: -20,
                    sparkline: {
                        enabled: true
                    }
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            background: "#e7e7e7",
                            strokeWidth: '97%',
                            margin: 5, // margin pixels
                            dropShadow: {
                                enabled: true,
                                top: 2,
                                left: 0,
                                color: '#999',
                                opacity: 1,
                                blur: 2
                            }
                        },
                        dataLabels: {
                            name: {
                                show: false
                            },
                            value: {
                                offsetY: -2,
                                fontSize: '0'
                            }
                        }
                    }
                },
                grid: {
                    padding: {
                        top: 20
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'light',
                        shadeIntensity: 0.4,
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        gradientToColors: [colors[type]],
                        stops: [0, 50, 53, 91]
                    },
                },
                labels: [''],
            };
        } else {
            var options = {
                chart: {
                    height: 110,
                    type: 'radialBar'
                },
                series: [score],
                plotOptions: {
                    radialBar: {
                        track: {
                            background: "#e7e7e7",
                            strokeWidth: '97%',
                            margin: 2, // margin pixels
                        },
                        dataLabels: {
                            name: {
                                show: false
                            },
                            value: {
                                offsetY: -2,
                                fontSize: '0'
                            }
                        }
                    }
                },
                grid: {
                    padding: {
                        top: 5
                    }
                },
                labels: [''],
              }
        }

        if (score) {
            var chart = new ApexCharts(document.querySelector("#" + type), options);
            chart.render();
        }
    }

    useEffect(() => {
        console.log('state', state);
        if (state) {
            setDataSelected(state);
        }
        document.body.className = '';
    }, []);

    useEffect(() => {
        if (dataSelected) {
            getData();
            let doc = dataSelected[0].doc_number.length === 14 ? cnpjMask(dataSelected[0].doc_number) : cpfMask(dataSelected[0].doc_number)
            setDocreport(doc);
            rendeGraph((dataSelected[0].esg_score.Ambiental * 100) / 5, 'ambiental');
            rendeGraph((dataSelected[0].esg_score.Social * 100) / 5, 'social');
            rendeGraph((dataSelected[0].esg_score.Governança * 100) / 5, 'governanca');
            rendeGraph((dataSelected[0].esg_score.iESGscan * 100) / 5, 'score');
            
            console.log(data);
        }
    }, [dataSelected]);

    useEffect(() => {
        if (dataSelected && dataSelected[0]) {
            // Limpar e re-renderizar apenas os gráficos visíveis baseado nos filtros
            if (filtrosEsfera.Ambiental) {
                const ambientalEl = document.getElementById('ambiental');
                if (ambientalEl) {
                    ambientalEl.innerHTML = '';
                    rendeGraph((dataSelected[0].esg_score.Ambiental * 100) / 5, 'ambiental');
                }
            }
            if (filtrosEsfera.Social) {
                const socialEl = document.getElementById('social');
                if (socialEl) {
                    socialEl.innerHTML = '';
                    rendeGraph((dataSelected[0].esg_score.Social * 100) / 5, 'social');
                }
            }
            if (filtrosEsfera.Governança) {
                const governancaEl = document.getElementById('governanca');
                if (governancaEl) {
                    governancaEl.innerHTML = '';
                    rendeGraph((dataSelected[0].esg_score.Governança * 100) / 5, 'governanca');
                }
            }
        }
    }, [filtrosEsfera, dataSelected]);

    const handleTabSelect = (tab) => {
        console.log(tab, data);
        setActiveTab(tab);
    };

    const handleFilterChange = (esfera) => {
        setFiltrosEsfera(prev => ({
            ...prev,
            [esfera]: !prev[esfera]
        }));
    };

    const getData = async () => {
        setLoad(true);
        try {
            const url = config.get('urlbase') + '/reports/v2/get-report?formato=json&customercnpj=' + JSON.parse(localStorage.getItem('userInfos')).data.customercnpj + '&data_relatorio=' + dataSelected[0].data_relatorio + '&documento=' + dataSelected[0].doc_number;
            const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token };
            const data = (await axios.get(url, { headers })).data;
            setData(data.Item);
            handleTabSelect('riscos');
            setLoad(false);
        } catch (error) {
            setLoad(false);
            console.log(error);
            toastr.error('Erro ao filtrar o relatório');
        }
    }
    
    return (
        <>
            <HeaderComponent />
            <section className='panel-default'>
            <div className="mb-4">
                    <h5 className="mb-0">Relatório de Riscos ESG </h5>
                    <Dropdown style={{ position: 'absolute', top: '16px', right: '29px', zIndex: 1000 }} >
                        <Dropdown.Toggle variant="outline-secondary" className="btn-sm" id="dropdownFilterBtn" data-bs-toggle="dropdownFilter" aria-expanded="false">Filtros ESG</Dropdown.Toggle>
                        <Dropdown.Menu className="p-3">
                            <Form.Check
                                type="checkbox"
                                id="filter-social"
                                label="Social"
                                checked={filtrosEsfera.Social}
                                onChange={() => handleFilterChange('Social')}
                            />
                            <Form.Check
                                type="checkbox"
                                id="filter-governanca"
                                label="Governança"
                                checked={filtrosEsfera.Governança}
                                onChange={() => handleFilterChange('Governança')}
                            />
                            <Form.Check
                                type="checkbox"
                                id="filter-ambiental"
                                label="Ambiental"
                                checked={filtrosEsfera.Ambiental}
                                onChange={() => handleFilterChange('Ambiental')}
                            />
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="d-flex justify-content-between mb-3">
                    <div><h3><a href='/score'><b><i className='bi bi-arrow-left-circle cursor-pointer me-2'></i></b></a> {dataSelected && dataSelected[0]?.razao_social}</h3></div>
                    <span className='tx-tertiary'><b>{docreport}</b></span>
                </div>
                <div className='d-flex justify-content-between'>
                    {filtrosEsfera.Ambiental && (
                        <div className='rect-content-base d-flex justify-content-between align-items-center' style={{width: '22%', height: '75px'}}>
                            <div style={{width: '230px', float: 'left'}}>
                                <p className='tx-primary mb-0 text-center'><b>Ambiental</b></p>
                                <p className='text-center mb-0 fs-5'><b>{dataSelected && dataSelected[0]?.esg_score.Ambiental}/<small>5.0</small></b></p>
                            </div>
                            <div style={{width: '145px', float: 'left'}}>
                                <div id='ambiental' style={{ width: '176px', margin: '0 auto' }}></div>
                            </div>
                        </div>
                    )}
                    {filtrosEsfera.Social && (
                        <div className='rect-content-base d-flex justify-content-between align-items-center' style={{width: '22%', height: '75px'}}>
                            <div style={{width: '230px', float: 'left'}}>
                                <p className='tx-tertiary mb-0 text-center'><b>Social</b></p>
                                <p className='text-center mb-0 fs-5'><b>{dataSelected && dataSelected[0]?.esg_score.Social}/<small>5.0</small></b></p>
                            </div>
                            <div style={{width: '145px', float: 'left'}}>
                                <div id='social' style={{ width: '176px', margin: '0 auto' }}></div>
                            </div>
                        </div>
                    )}
                    {filtrosEsfera.Governança && (
                        <div className='rect-content-base d-flex justify-content-between align-items-center' style={{width: '22%', height: '75px'}}>
                            <div style={{width: '230px', float: 'left'}}>
                                <p className='tx-secondary mb-0 text-center'><b>Governança</b></p>
                                <p className='text-center mb-0 fs-5'><b>{dataSelected && dataSelected[0]?.esg_score.Governança}/<small>5.0</small></b></p>
                            </div>
                            <div style={{width: '145px', float: 'left'}}>
                                <div id='governanca' style={{ width: '176px', margin: '0 auto' }}></div>
                            </div>
                        </div>
                    )}
                    <div className='rect-content-base d-flex justify-content-between align-items-center' style={{width: '22%', height: '75px'}}>
                        <div style={{width: '230px', float: 'left'}}>
                            <p className='tx-secondary mb-0 text-center'><b>ESGscan Score</b></p>
                            <p className='text-center mb-0 fs-5'><b>{dataSelected && dataSelected[0]?.esg_score.iESGscan}/<small>5.0</small></b></p>
                        </div>
                        <div style={{width: '145px', float: 'left'}}>
                            <div id='score'></div>
                        </div>
                    </div>
                </div>
                <Nav variant="pills" className='mb-3 mt-4' activeKey={activeTab} onSelect={handleTabSelect}>
                    <Nav.Item>
                        <Nav.Link eventKey="riscos">Riscos ESG Escaneados</Nav.Link>
                    </Nav.Item>
                    {docreport?.length === 18 && 
                        <>
                            <Nav.Item>
                                <Nav.Link eventKey="grupo">Grupo Econômico</Nav.Link>
                            </Nav.Item>
                        </>
                    }
                    <Nav.Item>
                        <Nav.Link eventKey="cnpjs">Participação em Empresas</Nav.Link>
                    </Nav.Item>
                    {docreport?.length === 18 &&
                        <>
                            <Nav.Item>
                                <Nav.Link eventKey="empresas">Empresas dos Sócios</Nav.Link>
                            </Nav.Item>
                        </>
                    }
                    {docreport?.length === 18 && 
                        <>
                            <Nav.Item>
                                <Nav.Link eventKey="gestao">Gestão de Resíduos</Nav.Link>
                            </Nav.Item>
                        </>
                    }
                    <Nav.Item>
                        <Nav.Link eventKey="frameworks">Frameworks ESG</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="midias">Mídias Negativas</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="processos">Processos Judiciais</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="carbono">Carbono</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="dados">Dados</Nav.Link>
                    </Nav.Item>
                </Nav>

                <Row>
                    {activeTab === 'riscos' && <ReportRisks dados={data} filtrosEsfera={filtrosEsfera}></ReportRisks>}
                    {activeTab === 'grupo' && <ReportGroup dados={data}></ReportGroup>}
                    {activeTab === 'cnpjs' && <ReportCNPJs dados={data}></ReportCNPJs>}
                    {activeTab === 'empresas' && <ReportEmpresas dados={data}></ReportEmpresas>}
                    {activeTab === 'gestao' && <ReportGestao dados={data}></ReportGestao>}
                    {activeTab === 'frameworks' && <ReportFrameworks dados={data}></ReportFrameworks>}
                    {activeTab === 'processos' && <ReportProcessos dados={data} reportData={dataSelected}></ReportProcessos>}
                    {activeTab === 'midias' && <ReportMidias dados={data} reportData={dataSelected}></ReportMidias>}
                    {activeTab === 'carbono' && <ReportCarbono dados={data}></ReportCarbono>}
                    {activeTab === 'dados' && <ReportDados dados={data}></ReportDados>}
                </Row>
            </section>
        </>
    )
}
export default ReportDetails;